// AudioStreamSender.ts
import logger from '@/utils/logger';
import globalHxxlConfig from '@/lib/HxxlConfig';

const sendMsgHistory = async (msgHistory: any[]) => {
  try {
    const response = await fetch("https://ai.hubeixinli.com/aitalk/talkaimsg", {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        owner: globalHxxlConfig.getOwner(),
        uid: globalHxxlConfig.getUid(),
        talkId: globalHxxlConfig.getTalkId(),
        msgHistory
      }),
    });
    if (!response.ok) logger.error('发送 msgHistory 失败:', response.statusText);
    else logger.log('msgHistory 已成功发送');
  } catch (error) {
    logger.error('发送 msgHistory 出错:', error);
  }
}

export default sendMsgHistory

